module.exports = __webpack_public_path__ + "static/media/accenture_sust_val_updapt_logo_img.e9477d6b.svg";